import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from "react-router-dom";
import './index.css';
import App from './App';

// import reportWebVitals from './reportWebVitals';
import { SessionProvider, useSession } from "context/SessionContext";
import { ShoppingCartProvider, useShoppingCart } from "context/ShoppingCartContext";

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  (
    <React.StrictMode>
      <SessionProvider>
        <ShoppingCartProvider>
          <BrowserRouter basename='/'>
            <App useSession={useSession} useShoppingCart={useShoppingCart} />
          </BrowserRouter>
        </ShoppingCartProvider>
      </SessionProvider>
    </React.StrictMode>
  )
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
// reportWebVitals();
